import { render, staticRenderFns } from "./CardPropertyDepartureReport.vue?vue&type=template&id=3fc0cb72&scoped=true&"
import script from "./CardPropertyDepartureReport.vue?vue&type=script&lang=js&"
export * from "./CardPropertyDepartureReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0cb72",
  null
  
)

export default component.exports
import {QField,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QField,QBtn,QTooltip}, component.options.components || {})
